import React, { useState } from "react";
import axios from "../api/axios";
import { useNavigate } from "react-router-dom";

const CheckCustomer = () => {
  const [step, setStep] = useState("choose"); // choose | form
  const [formData, setFormData] = useState({
    email: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleExistingSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post("/check-customer", formData, {
        headers: { "Content-Type": "application/json" },
      });

      const data = response.data;
      const isExistingCustomer = data.orders && data.orders.length > 0;

      if (isExistingCustomer) {
        const uniqueAddresses = [
          ...new Map(
            data.orders.map((order) => [
              `${order.address},${order.city},${order.state || ""},${order.zip}`,
              {
                name: order.full_name,
                address: order.address,
                city: order.city,
                state: order.state || "",
                zip: order.zip,
              },
            ])
          ).values(),
        ];

        localStorage.setItem(
          "customerInfo",
          JSON.stringify({
            existing: true,
            fullName: data.full_name || "",
            email: data.email || formData.email,
            phone: data.phone || formData.phone,
            addresses: uniqueAddresses,
          })
        );
      } else {
        localStorage.setItem(
          "customerInfo",
          JSON.stringify({
            existing: false,
            fullName: "",
            email: formData.email,
            phone: formData.phone,
            addresses: [],
          })
        );
      }

      navigate("/checkout");
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleNewUser = () => {
    localStorage.setItem(
      "customerInfo",
      JSON.stringify({
        existing: false,
        fullName: "",
        email: "",
        phone: "",
        addresses: [],
      })
    );
    navigate("/checkout");
  };

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-body">
          <h2 className="card-title h4 mb-4 text-center">Welcome to Checkout</h2>

          {step === "choose" && (
            <div className="d-flex flex-column">
              <button
                onClick={() => setStep("form")}
                className="btn btn-primary btn-block mb-3"
              >
                I am an Existing Customer
              </button>
              <button
                onClick={handleNewUser}
                className="btn btn-success btn-block"
              >
                I am a New Customer
              </button>
            </div>
          )}

          {step === "form" && (
            <form onSubmit={handleExistingSubmit} className="mt-3">
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email"
                  value={formData.email}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="phone"
                  placeholder="Enter phone number"
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-control"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary btn-block"
              >
                {loading ? "Checking..." : "Continue to Checkout"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckCustomer;
